import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StockService} from '../../../shared/services/stock.service';
import {Stock} from '../../../shared/models/Stock';
import {SpianalyticsService} from '../../../shared/services/spianalytics.service';
import {Centre} from '../../../shared/models/centre';
import {CentresService} from '../../../shared/services/centre.service';
import {BonReception} from '../../../shared/models/BonReception';
import { Product } from 'src/app/shared/models/product';
import {ProductsService} from '../../../shared/services/products.service';
import {DashboardQueryService} from '../../../shared/services/dashboard-query.service';
import {Subject} from 'rxjs';
import * as xlsx from 'xlsx';
import {AuthenticationService} from '../../../shared/services/authentication.service';


declare let $: any;
declare let pivot: any;
declare let renderTableLinearData: any;
declare let renderTablePivotData: any;
declare let aggregatorTemplates: any;

@Component({
  selector: 'app-chart-pivot-table',
  templateUrl: './chart-pivot-table.component.html',
  styleUrls: ['./chart-pivot-table.component.scss']
})
export class ChartPivotTableComponent implements OnInit, OnDestroy {

  @Input() selectedYear = new Date().getFullYear();
  @Input() selectedCentreId = -1;
  @Input() selectedProductId = -1;

  products: Product[];
  centres: Centre[];
  cols: any[];
  stocks: Stock[];
  bonReceptions: BonReception[];
  selectedStatus: any;

  yearList: number[] = [];
  dateDebut = new Date();
  dateFin = new Date();

  loading: boolean;
  destroy$: Subject<boolean> = new Subject<boolean>();

  blocked: boolean;

  constructor(
    private router: Router,
    private dashboardQueryService: DashboardQueryService,
    private stockService: StockService,
    private centresService: CentresService,
    private authenticationService: AuthenticationService,
    private productsService: ProductsService) {
  }

  ngOnInit(): void {

    if (this.authenticationService.hasPermission(['AGENT_CENTRE'])) {
      this.selectedCentreId = JSON.parse(localStorage.getItem('currentUser')).centerId;
    } else {
      this.selectedCentreId = -1;
    }

    for (let i = this.selectedYear; i > this.selectedYear - 4; i--) {
      this.yearList.push(i);
    }

    const year = new Date().getFullYear();
    this.dateDebut = new Date('01/01/' + year);

    this.drawChart();
  }

  drawChart() {
    const parameters = [
      {key : 'year', value: this.selectedYear},
      {key : 'centreId', value: this.selectedCentreId},
      {key : 'centerId', value: this.selectedCentreId},
      {key : 'productId', value: this.selectedProductId},
    ];
    this.blocked = true;
    this.dashboardQueryService.runQuery('BP_QUANTITY_PRIX_SEMAINE', parameters)
      .subscribe(data => {
        if (data && data.length > 0) {
          this.drawPivotTable(data,['Mois', 'Semaine'], ['centre'], ['Prix Total TND'], '#query12', 'true');
        }
        this.blocked = false;
      }, err => {
        console.log(err);
      });
  }

  drawPivotTable(input: any, rows: any, cols: any, aggVals: any, divId: any, usePivotData: string){
    $(divId).html('loading...');
    let renderers = {
      'Table' : this.renderTable
    };
    let inputOpts = {
      rows: rows,
      cols: cols,
      vals: aggVals,
      renderers: renderers,
      rendererName: 'Table',
      filter : function(){
        return true;
      },
      rendererOptions: {
        usePivotData: usePivotData
      },
      renderer : renderers['Table'],
      aggregator: aggregatorTemplates.sum()(aggVals),
      aggregatorName: "Sum",
    };

    //let matrice = PivotData(input, inputOpts);
    //console.log(matrice);
    pivot(
      input,
      inputOpts,
      'fr',
      $(divId)
    );
  }

  renderTable: any = function(pivotData, opts) {

    let hasProp = {}.hasOwnProperty;
    let rendereType = 'Table';

    let defaultTableOptions =  {
      table: {
        clickCallback: null,
        rowTotals: true,
        colTotals: true
      },
      localeStrings: {
        totals: 'Totals'
      }
    };
    opts = $.extend(true, {}, defaultTableOptions, opts);
    let colAttrs = pivotData.colAttrs;
    let rowAttrs = pivotData.rowAttrs;
    let rowKeys = pivotData.getRowKeys();
    let colKeys = pivotData.getColKeys();

    if ( opts.usePivotData === 'false') {
      return renderTableLinearData(pivotData, rowAttrs, colAttrs);
    } else {
      return renderTablePivotData(pivotData, rowAttrs, colAttrs, rowKeys, colKeys, opts);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
